module.exports = __webpack_public_path__ + "img/chevron-down.249cbe6c.svg";